import "./register.css"
import React, {lazy, Suspense} from 'react';
import Spinner from 'react-bootstrap/Spinner';

const LazyRegister = lazy(() => import('../register_landing/RegisterLanding'));

const RegisterLoader = () => (
    <Suspense fallback={
        <div className="flex justify-content-center pt-7">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    }>
        <LazyRegister/>
    </Suspense>
);

export default RegisterLoader;
